<template lang="pug">
div.mobile-checkout
  Breadcrumbs(v-if="configApp.isBreadcrumbs")
  router-view
  RecaptchaTerms(v-if="!configApp.isOperator && !configApp.isEmployee")
  CardPurchaseSummary(
    label="Total"
    :isDisplayPayment="isDisplayPayment"
    :value="valueAmount"
    :labelInstallment="labelInstallment"
    :valueInstallment="valueInstallment"
    :recurrent="recurrent"
    :campaign="campaign"
    @openModal="openModal"
  )
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/molecules/Breadcrumbs.vue'
import CardPurchaseSummary from '@/components/molecules/CardPurchaseSummary.vue'
import RecaptchaTerms from '@/components/atoms/RecaptchaTerms.vue'
import { currency } from '@/utils/filters'

export default {
  name: 'MobileCheckout',
  computed: {
    ...mapState(['configApp']),
    ...mapState('product', ['alias', 'recurrent']),
    ...mapState('plan', ['annualValue', 'precoTotal', 'parcela', 'parcelasPrecos', 'campaign']),
    ...mapState('payment', ['typePayment', 'parcels']),
    ...mapGetters('payment', ['isAnnual']),
    isBreadcrumbs () {
      return /saude|pet/.test(this.alias)
    },
    isDisplayPayment () {
      return !this.configApp.isEmployee
    },
    valueAmount () {
      if (this.isAnnual) return currency(this.annualValue)
      return currency(this.precoTotal)
    },
    selectedInstallment () {
      return Number(this.parcels || this.parcela) || this.parcelasPrecos?.length || undefined
    },
    labelInstallment () {
      if (!this.selectedInstallment) {
        return 'Até 12x de'
      }
      return this.selectedInstallment === 1 ? 'A vista' : `${this.selectedInstallment}x de`
    },
    valueInstallment () {
      if (this.recurrent) {
        return this.isAnnual ? 'Anual' : 'Mensal'
      }
      if (!this.selectedInstallment) {
        return this.getInstallmentValue(11)
      }
      return this.selectedInstallment === 1 && this.typePayment.title
        ? this.typePayment.title
        : this.getInstallmentValue(this.selectedInstallment - 1)
    }
  },
  components: {
    Breadcrumbs,
    CardPurchaseSummary,
    RecaptchaTerms
  },
  filters: {
    currency
  },
  methods: {
    openModal () {
      this.$emit('openModal')
    },
    getInstallmentValue (index) {
      return currency(this.parcelasPrecos && this.parcelasPrecos[index])
    }
  }
}
</script>
